import React from "react";
import { Box, Container, Heading, Text } from "@chakra-ui/react";

export default function NotFound() {
    return (
        <Box bg="offwhite.100" minH="100vh">
            <Container maxW="container.lg" py={{ base: 12, md: 20 }}>
                <Heading as="h1" size="2xl" mb={6}>
                    Page not found
                </Heading>
                <Text fontSize="xl">
                    The page you are looking for does not exist.
                </Text>
            </Container>
        </Box>
    );
}
